import React from 'react';

import Switch from 'react-switch';
import { navigateTo } from 'gatsby-link';
import * as S from './style';
import * as T from '../../components/Typography';
import { Row, Col } from '../../components/Grid';
import { SectionLayout } from '../../components/Layouts';
import Image from '../../components/Image';
import Button from '../../components/Button';
import { navRoutes } from '../../constants';
import composeStyle from '../../utils/composeStyle';

import { colors } from '../../theme';

const HeadingComponents = composeStyle(T.H1, `H2`, 'H3');
const HeadingComponentsSmall = composeStyle(T.H2, `H2`, 'H3');
const subTitleComponents = composeStyle(T.P24, `P24`, 'P16');

const smallHeaders = [
  'FAQs',
  'about',
  'impact',
  'timeCreditsWalesEnglish',
  'timeCreditsWalesWelsh',
  'timeCreditsEngland',
];

const images = {
  home: {
    desktop: 'headerBackgroundGroup',
    tablet: 'headerMobileBigGroup',
  },
  memberHome: {
    desktop: 'headerBackgroundCinema',
    tablet: 'headerMobileCinema',
  },
  spendPartnerHome: {
    desktop: 'headerBackgroundGym',
    tablet: 'headerMobileGym',
  },
  earnGroupHome: {
    desktop: 'headerBackgroundGardening',
    tablet: 'headerMobileGardening',
  },
  commissioner: {
    desktop: 'headerBackgroundFlipChart',
    tablet: 'headerMobileFlipChart',
  },
  FAQs: {
    desktop: 'headerBackgroundReading',
    tablet: 'headerMobileReading',
  },
  about: {
    desktop: 'headerBackgroundGroupTwo',
    tablet: 'headerMobileGroup',
  },
  impact: {
    desktop: 'headerBackgroundYoga',
    tablet: 'headerMobileYoga',
  },
  timeCreditsWalesEnglish: {
    desktop: 'headerBackgroundSwimming',
    tablet: 'headerMobileSwimming',
  },
  timeCreditsWalesWelsh: {
    desktop: 'headerBackgroundSwimming',
    tablet: 'headerMobileSwimming',
  },
  timeCreditsEngland: {
    desktop: 'headerBackgroundGallery',
    tablet: 'headerMobileGallery',
  },
};

const buttons = {
  memberHome: {
    text: 'Get started today',
    to: navRoutes.contactUsForm,
  },
  spendPartnerHome: {
    text: 'Get started today',
    to: navRoutes.spendPartnerForm,
  },
  earnGroupHome: {
    text: 'Get started today',
    to: navRoutes.earnGroupsForm,
  },
  commissioner: {
    text: 'Get started today',
    to: navRoutes.commissionersForm,
  },
};

const Header = ({ page, title, subtitle }) => {
  const SubTitleComponent = subTitleComponents;
  const small = smallHeaders.includes(page);
  const Heading = small ? HeadingComponentsSmall : HeadingComponents;

  const onChangeLanguage = () => {
    if (page === 'timeCreditsWalesEnglish') navigateTo(navRoutes.timeCreditsWalesWelsh);
    if (page === 'timeCreditsWalesWelsh') navigateTo(navRoutes.timeCreditsWalesEnglish);
  };

  let activeLanguage = 'english';
  if (page === 'timeCreditsWalesWelsh') activeLanguage = 'welsh';

  return (
    <S.Wrapper small={small}>
      <SectionLayout style={{ minHeight: small ? 'auto' : '500px' }}>
        <S.DesktopWrapper>
          <S.ImageWrapper small={small}>
            <Image image={images[page].desktop} />
          </S.ImageWrapper>
        </S.DesktopWrapper>
        <S.TabletAndMobileWrapper>
          <S.ImageWrapper small={small}>
            <Image image={images[page].tablet} />
          </S.ImageWrapper>
        </S.TabletAndMobileWrapper>

        <Row mb={3} mbT={2} mtM={1}>
          <Col w={[4, 6, 8]}>
            <Heading color="midnight" taT="center" taM="center" mtT={4} mtM={3} d="block">
              {title}
            </Heading>
          </Col>
          <Col w={[4, 6, 12]}>{small && <S.Line />}</Col>
        </Row>
        {subtitle && (
          <Row>
            <Col w={[4, 6, 8]}>
              <SubTitleComponent color="black3" taT="center" taM="center" as="pre">
                {subtitle}
              </SubTitleComponent>
            </Col>
          </Row>
        )}
        {(page === 'timeCreditsWalesEnglish' || page === 'timeCreditsWalesWelsh') && (
          <Row>
            <Col w={[4, 6, 12]}>
              <S.SwitchWrapper>
                <T.H4 color={activeLanguage === 'english' ? 'pink' : 'midnight'}>English</T.H4>
                <T.H4 color="pink" ml={1} mr={1}>
                  /
                </T.H4>
                <T.H4 color={activeLanguage === 'welsh' ? 'pink' : 'midnight'} mr={2}>
                  {activeLanguage === 'english' ? 'Welsh' : 'Cymraeg'}
                </T.H4>
                <Switch
                  onChange={onChangeLanguage}
                  checked={activeLanguage === 'welsh'}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offHandleColor={colors.white}
                  onHandleColor={colors.white}
                  offColor={colors.pink}
                  onColor={colors.pink}
                />
              </S.SwitchWrapper>
            </Col>
          </Row>
        )}

        {buttons[page] && (
          <Row mt={4} jcT="center">
            <Col w={[4, 3, 4]}>
              <Button to={buttons[page].to} gradient="pinkGrad" large external caps={false}>
                {buttons[page].text}
              </Button>
            </Col>
          </Row>
        )}
      </SectionLayout>
    </S.Wrapper>
  );
};

export default Header;
